import React ,{Component} from "react";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {Navigation} from "./partials/Global/Navigation";
import {FooterBody} from "./partials/Global/FooterBody";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";
import {Col, Container, Row} from "react-bootstrap";


class Pillars extends Component {
    render() {
        return (
            <div>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main>
                    <header className="page-header section-padding pt-0">
                        <Container className="mt-80">
                            <Row >
                                <Col lg={8}>
                                    <div className="caption">
                                        <div className="sub-title">
                                            <a href={"/"}><span>خانه</span></a>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>معرفی شرکت</span>
                                            <span>&nbsp; / &nbsp;</span>
                                            <span>ارکان جهت ساز</span>
                                        </div>
                                        <h2 className="fz-25">ارکان جهت‌ساز و استراتژی‌های شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p>
                                            به منظور ایجاد هماهنگي و همسویی در شرکت، ترسیم چشم‌انداز و حرکت به سمت آن، پروژه <b>«تدوین سند راهبردی شرکت سرمایه‌ گذاری عمران و توسعه پایدار ایرانیان»</b>، تعریف و در حال انجام می‌باشد که مرحله مطالعه و تحلیل بازار تقریباً به اتمام رسیده و ارکان جهت‌ساز و استراتژی‌ها بطور کلی بصورت پیش‌نویس تهیه شده است. برای نهایی کردن این سند، <b>کمیته استراتژی و برنامه‌ ریزی</b> متشکل از معاونین و مدیران کلیدی شرکت تشکیل گردیده و موارد مربوطه طی جلسات منظم، بحث و بررسی می‌شود.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <br/><br/>
                            <Row >
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">رسالت و ماموریت شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p style={{color: '#8c0a35'}}>
                                            بهبود کیفیت زندگی و <b>تامین منافع اجتماعی شهروندان و توسعه اقتصادی کشور</b>
                                        </p>
                                        <p style={{color: '#8c0a35'}}>
                                            <b>رویکرد سوددهی پایدار و بلندمدت</b> برای شرکت و سهامداران (بانک اقتصاد نوین)
                                        </p>
                                        <p style={{color: '#8c0a35'}}>
                                            در قالب انجام <b>کسب‌وکارهای ذیل</b>:
                                        </p>
                                        <p style={{color: '#8c0a35'}}><ul>
                                            <li>- تاکید بر مدیریت پیمان و ورود به پروژه‌های ساختمانی</li>
                                            <li>- توجه به عامل چهارم بعنوان یک کسب و کار جدید</li>
                                            <li>- توسعه زنجیره خدمات بازسازی شعب از جمله تعمیر و نگهداری</li>
                                            <li>- توسعه فرآیند بازسازی به موضوعاتی بجز شعب بانک اقتصاد نوین</li>
                                            <li>- توسعه فعالیت‌های شرکت در حوزه بازاریابی و فروش</li>
                                            <li>- ارائه خدمات یکپارچه در صنعت ساختمان از مرحله ارزیابی تا بازسازی و فروش املاک</li>
                                            <li>- فعالیت‌های استارت‌آپی و فناورانه به‌خصوص در حوزه ارائه خدمات فروش، نگهداری ساختمان و حقوقی</li>
                                        </ul></p>
                                        <p style={{color: '#8c0a35'}}>
                                            صدور گواهی ساختمان براساس موضوع کیفیت، بهره برداری، بازاریابی و فروش
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <br/><br/>
                            <Row>
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">چشم‌انداز شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p style={{color: '#0070c0'}}>
                                            کسب <b>جایگاه در میان 5 شرکت‌</b> فعال در کسب‌وکارهای صنعت املاک و ساختمان مرتبط با بانک‌های خصوصی کشور، از منظر کیفیت و گستره فعالیت‌ها
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <br/><br/>
                            <Row>
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">ارزش‌های محوری و بنیادین شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p style={{color: '#480d89'}}>
                                            ایجاد <b>محیط حرفه‌ای، دانش‌محور، کار محور</b>، وفادار به معیارهای اخلاقی، انسانی و صنفی
                                        </p>
                                        <p style={{color: '#480d89'}}>
                                            اعتقاد به <b>مسئولیت‌پذیری، پاسخگویی، هم‌افزایی</b>، همگرایی و کار گروهی
                                        </p>
                                        <p style={{color: '#480d89'}}>
                                            <b>آموزش مستمر</b> فردی، گروهی و ارتقاء دانش فنی و حرفه‌ای همکاران
                                        </p>
                                        <p style={{color: '#480d89'}}>
                                            <b>بهینه‌سازی و شفاف‌سازی مستمر فرآیندها</b> و برقراری انضباط مالی و اداری
                                        </p>
                                        <p style={{color: '#480d89'}}>
                                            وفادار به اصول ایمنی، بهداشتی، حفظ محیط‌ زیست، و <b>تقدم کیفیت بر کمیت در کاریابی</b>، طراحی و اجرا
                                        </p>
                                        <p style={{color: '#480d89'}}>
                                            <b>حفظ اصول رقابت و رضایت حقوق کلیه ذینفعان</b> شامل مشتریان، سهام داران، کارکنان، و ... در انجام ماموریت‌ها و فعالیت‌های شرکت
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            <br/><br/>
                            <Row>
                                <Col lg={8}>
                                    <div className="caption">
                                        <h2 className="fz-25">استراتژی‌های شرکت</h2>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="text mt-30 text-justify">
                                        <p style={{color: '#385623'}}>
                                            <b>متوازن ‌سازی سبد کسب و کار و درآمدی شرکت</b> (ایجاد جریان نقدی پایدار؛ تسهیم ریسک کل شرکت در میان کسب و کارها، برقراری توازن بین درآمد کسب‌وکارهای خدماتی و عملیاتی)
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>توسعه بازار کسب‌وکار ساخت‌وساز</b> (تعریف چند پروژه بزرگ‌متراژ با دوره ساخت سه تا پنج سال و چند پروژه کوتاه‌مدت با دوره ساخت یک تا سه سال و در قالب مدیر پیمان؛ توسعه بازار کسب‌وکار ساخت‌وساز و از محل پروژ‌ه‌های بیرون از بانک)
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>توسعه حوزه بازسازی</b> (غنی‌سازی کسب و کار بازسازی و الحاق بخش تعمیر و نگهداری به این حوزه؛ توسعه بازار بیرونی و اخذ پروژه از مشتریان در بخش‌هایی از بازار از جمله بازسازی ساختمان‌های اداری یا بازسازی شعب فروشگاه‌های زنجیره ای، مال‌های تجاری و....)
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>توسعه حوزه مدیریت املاک و فروش</b> (گستره از مرحله ارزیابی تا ارزش‌افزایی و فروش؛ ارائه خدمات حقوقی و ثبتی و مدیریت املاک در قالب یک استارت آپ به عموم مشتریان؛ ارائه خدمات ارزیابی مطالعات بازار و اقتصادی به بانک و سایر مشتریان؛ شناسایی املاک با قابلیت ساخت یا مولد سازی و ارزش‌افزایی از طریق تغییر کاربری، اخذ دستور نقشه، حل مشکل حقوقی و...) و یا از طریق بازسازی، یا هویت بخشی (برای املاک بزرگ؛ تبدیل شدن به بازوی فروش شرکت‌های تولید کننده مصالح ساختمانی یا پیمانکار جهت ایجاد ارزش افزوده و فروش املاکی تهاتری در اختیار)
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>ایجاد کسب و کار ارزیابی و صدور گواهی ساختمان</b>
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>ارائه خدمات عامل چهارم به بانک و سایر شرکت‌های سرمایه‌گذاری در صنعت ساختمان</b>
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>رویکرد تهاتر در درآمد و دریافت حق‌الزحمه از پروژه‌ها یا املاک با قابلیت ساخت یا ارزش‌افزایی</b>
                                        </p>
                                        <p style={{color: '#385623'}}>
                                            <b>تعامل با شرکت‌های سازنده و تولیدکنندگان مصالح ساختمانی بعنوان ذینفعان صنعت ساختمان</b>
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </header>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </div>
        );
    }
}

export default Pillars;
